import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { wikiLogin } from '../../utils/wikiAuth';
import { BookOpen, Lock, User } from 'lucide-react';
import styles from './WikiAdminLogin.module.css';

const WikiAdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await wikiLogin(formData.username, formData.password);
      if (result.success) {
        navigate('/wiki/admin');
      } else {
        setError(result.message || 'Ошибка входа');
      }
    } catch (err) {
      setError(err.message || 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer} style={{ '--admin-scene': "url('/background.png')" }}>
      <div className={styles.loginCard}>
        <div className={styles.logoSection}>
          <div className={styles.logoIcon}>
            <BookOpen size={48} />
          </div>
          <h1 className={styles.title}>Вики InterWorld</h1>
          <p className={styles.subtitle}>Вход для редакторов и администрации</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.loginForm}>
          {error && <div className={styles.errorMessage} role="alert">{error}</div>}

          <div className={styles.inputGroup}>
            <div className={styles.inputIcon}>
              <User size={20} />
            </div>
            <input
              type="text"
              placeholder="Логин"
              aria-label="Логин"
              autoComplete="username"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              className={styles.input}
              required
              autoFocus
            />
          </div>

          <div className={styles.inputGroup}>
            <div className={styles.inputIcon}>
              <Lock size={20} />
            </div>
            <input
              type="password"
              placeholder="Пароль"
              aria-label="Пароль"
              autoComplete="current-password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className={styles.input}
              required
            />
          </div>

          <button type="submit" disabled={loading} className={styles.loginButton}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <div className={styles.footer}>
          <a href="/wiki" className={styles.backLink}>
            ← Вернуться в Вики
          </a>
        </div>
      </div>
    </div>
  );
};

export default WikiAdminLogin;
